import UAParser from 'ua-parser-js';

export const useUserAgent = () => {
  const header = useRequestHeaders();
  const userAgent = computed(() => UAParser(header['user-agent']));
  return { userAgent };
};
